var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thickness-element',{attrs:{"value":_vm.value,"shopConfig":_vm.shopConfig,"disabled":_vm.disabled,"bendPart":false},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }